import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import Main from './Main';
import Khufu from './KhufuDetail';
import Waterdrop from './WaterdropDetail';
import Hotel from './NuitaLHotelDetail';
import Arcade from './Arcade';
import Simon from './Simon';
import Manifeste from './Manifeste';
import Stage2a from './stage2a';
import RealAugm from './RealAugm';


function AppClass() {
    return (
        <Router>
                <Routes>
                    <Route path="/khufu-s-escape" element={<Khufu/> } />
                    <Route path="/water-drops-journey" element={<Waterdrop />} />
                    <Route path="/nuit-a-l-hotel" element={<Hotel />} />
                    <Route path="/Arcade" element={<Arcade />} />
                    <Route path="/simon" element={<Simon />} />
                    <Route path="/Manifeste" element={<Manifeste />} />
                    <Route path="/RealAugm" element={<RealAugm />} />
                    <Route path="/stage2a" element={<Stage2a />} />
                    <Route path="/" element={<Main />} />
                </Routes>
        </Router>
    );

}


export default AppClass;